import {HierarchyService} from './../../service/hierarchy.service';
import {Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-timesheet-area',
  templateUrl: './timesheet-area.component.html',
  styleUrls: ['./timesheet-area.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TimesheetAreaComponent implements OnInit {
   _agents;
   _filteredAgents;
   _filterTmp;
   show = false;

  @ViewChild('query') queryInput: ElementRef;

  constructor(private hierarchyService: HierarchyService) {
  }

  ngOnInit() {
    this._filterTmp = this._filteredAgents = this._agents = [];
    console.log('filterTMP', this._filterTmp);
  }

  @Input()
  set agents(value) {
    // console.log(value)
    this._filterTmp = this._filteredAgents = this._agents = value;
    if (this.queryInput) {
      this.queryInput.nativeElement.value = '';
    }
  }

  filter(query: string) {
      this._filteredAgents = (query.length > 0 ?
        this._filterTmp.filter((d)  => {
          const name = [d.firstName, d.lastName, d.username].join(' ');
           if ( name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
             return d;
           }
        }) :
        this._filterTmp);
  }

}



// WEBPACK FOOTER //
// ./src/app/view/timesheet-area/timesheet-area.component.ts